import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BaseMessageComponent } from '../../../utils/base-message.component';

@Component({
  selector: 'app-ownership-taken-message',
  templateUrl: './ownership-taken-message.component.html',
  styleUrls: ['./ownership-taken-message.component.scss']
})
export class OwnershipTakenMessageComponent extends BaseMessageComponent {

  @Output() redirectLogout = new EventEmitter<any>();
  constructor() {
    super();
  }

  logout() {
    this.startProcessing();
    this.redirectLogout.emit();
  }
}
